import { validLocales } from '$lib/i18n';

export const match = (locale: string): boolean => validLocales.includes(locale);
